import {fetchAdmin1, fetchAdmin2, fetchAdmin3} from '../../../utils/location';

export async function getAdminData(
  countryCode: string,
  admin1IdOrName: string,
  admin2IdOrName?: string,
  admin3IdOrName?: string
) {
  if (!countryCode) return;
  if (!admin1IdOrName) return;

  const admin1Response = await fetchAdmin1(countryCode);
  console.log({
    admin1Response,
  });
  const admin1 = admin1Response.find(
    admin1 =>
      admin1.admin1Name === admin1IdOrName ||
      admin1.admin1Id.toString() === admin1IdOrName
  );

  if (!admin1) return;

  const admin2Response = await fetchAdmin2(
    countryCode,
    admin1.admin1Id.toString()
  );

  const admin2 = admin2Response.find(
    admin2 =>
      admin2.admin2Name === admin2IdOrName ||
      admin2.admin2Id.toString() === admin2IdOrName
  );

  if (!admin2) {
    return {
      admin1,
    };
  }

  const admin3Response = await fetchAdmin3(
    countryCode,
    admin1.admin1Id.toString(),
    admin2.admin2Id.toString()
  );

  const admin3 = admin3Response.find(
    admin3 =>
      admin3.admin3Name === admin3IdOrName ||
      admin3.admin3Id.toString() === admin3IdOrName
  );

  if (!admin3) {
    return {
      admin1,
      admin2,
    };
  }

  return {
    admin1,
    admin2,
    admin3,
  };
}
